export const environment = {
  production: true,
  base_url: 'https://api-beuatportal.fingent.net/api',
  brokerRoleName: "B+E Broker",
  intercom_api: '',
  //intercom_api: 'vfdtgib4',
  share_url: 'http://be-shareuat.fingent.net',
  video_name: 'B+E_H264.mov',
  siteurl: 'https://be-uatportal.fingent.net',
  WPsiteurl: 'https://be-uat.fingent.net/',
  auth0: {
    domain: 'benetlease-dev.auth0.com',
    tenant: 'benetlease-dev',
    customdomain: 'login.tradenetlease.com',
    configurationBaseUrl: 'https://cdn.auth0.com/',
    clientId: 'LUWWpJIyVbpw36nNPBye5QAaWFS2Y3iT',
    callbackURL: 'https://be-uatportal.fingent.net',
    connection: "BE-UAT",
    url: 'https://login.tradenetlease.com/',
    tokenRefreshTime: 0,
    redirect: false,
    defaultPassword: "Abcd@123"
  },

  auth0API: {
    client_id: 'ILHxm4M4eR87e2WWsGPIyPQh2PhYMxpr',
    client_secret: 'l2OVObzjwnjDPlZ2pjo6135RmB7UZ-VEpUkNsRlJyUX2LRaLC8yNnHmT8dwQX2dU',
    grant_type: 'client_credentials',
    url: 'https://benetlease-dev.auth0.com/'
  },
  jwtTokenExpiry: 3,
  importExcelPath: 'https://be-prd.s3.amazonaws.com/BE/ImportTemplateUAT',
  stockNewsAPIToken: 'd9sry2skkb8zamv12vclrzsibrpkydzx2l84ulat',
  rapidapihost: 'apidojo-yahoo-finance-v1.p.rapidapi.com',
  rapidapikey: '05e6dcddd4msha967cba4b6adfeap1093d3jsn4a824503bfa1'
};
